module.exports = __webpack_public_path__ + "static/media/brasil.fdd476d2.jpg";